
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"panel\">\n  <header id=\"legal-header\">\n    <h1 id=\"fxa-tos-header\">{{#t}}Terms of Service{{/t}}</h1>\n  </header>\n\n  <section class=\"hidden\">\n    <div class=\"error\"></div>\n\n    <article id=\"legal-copy\">\n    </article>\n\n    {{#canGoBack}}\n      <div class=\"button-row\">\n        <button id=\"fxa-tos-back\" class=\"back\">{{#t}}Back{{/t}}</button>\n      </div>\n    {{/canGoBack}}\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/tos.mustache
// module id = 305
// module chunks = app